import { isNil } from 'lodash';
import { SubscriptionBundle } from '../../common/bundle.types';
import { EditPlatformBundleDispatcher } from './editPlatformBundle.vm';

export const getPlatformBundleModalCta = ({
  editedBundle,
  dispatch,
}: {
  editedBundle?: SubscriptionBundle;
  dispatch: EditPlatformBundleDispatcher;
}) => {
  if (!editedBundle) return [];

  return [
    ...(!isNil(editedBundle?.upgradeDeeplinkUrl)
      ? [
          {
            label: 'Copy link',
            onClick: () =>
              dispatch('copyUpgradeLink', editedBundle.upgradeDeeplinkUrl),
          },
        ]
      : []),
    ...(editedBundle?.pushNotificationUsageCount < 2
      ? [
          {
            label: 'Create Push Notification',
            onClick: () => dispatch('openPnModal'),
          },
        ]
      : []),
  ];
};

export const getPnDefaultMessage = (creatorName?: string) => {
  if (!creatorName)
    return `Hey! My Exclusive 🌟 subscription is now live! Click to learn how to join it`;

  return `Hey, this is ${creatorName}! My Exclusive 🌟 subscription is now live! Click to learn how to join it`;
};
